import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const LockClosed: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7C10.8954 7 9.99997 7.89543 9.99997 9V10H14V9C14 7.89543 13.1045 7 12 7ZM7.99997 9V10H7.5C6.67157 10 6 10.6716 6 11.5V17.5C6 18.3284 6.67157 19 7.5 19H16.5C17.3284 19 18 18.3284 18 17.5V11.5C18 10.6716 17.3284 10 16.5 10H16V9C16 6.79086 14.2091 5 12 5C9.79083 5 7.99997 6.79086 7.99997 9ZM12 15.75C12.6904 15.75 13.25 15.1904 13.25 14.5C13.25 13.8096 12.6904 13.25 12 13.25C11.3096 13.25 10.75 13.8096 10.75 14.5C10.75 15.1904 11.3096 15.75 12 15.75Z"
      fill="currentColor"
    />
  </svg>
);
